import { Task } from '../lib/types/database.types'

type TaskNotificationPayload = {
  taskId: string
  taskTitle: string
  status?: string
  priority?: string
  type?: string
  appName?: string
  dueDate?: string | null
  description?: string | null
  requestedBy?: string
  approvalPath?: string
  outcome?: 'approved' | 'rejected'
  reviewedBy?: string
  taskPath?: string
}

const postNotification = async (endpoint: string, body: unknown, successLog: string, failureLog: string) => {
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })

    const responseBody = await response.text()

    if (!response.ok) {
      console.error(failureLog, {
        endpoint,
        status: response.status,
        body: responseBody,
      })
      return false
    }

    console.log(successLog, {
      endpoint,
      status: response.status,
      body: responseBody,
    })
    return true
  } catch (error) {
    console.error(failureLog, { endpoint, error })
    return false
  }
}

export const buildTaskNotificationPayload = (task: Task): TaskNotificationPayload => ({
  taskId: task.id,
  taskTitle: task.title,
  status: task.status,
  priority: task.priority,
  type: task.type,
  appName: task.related_app,
  dueDate: task.overall_due_date,
  description: task.description,
})

export const sendTaskAssignedEmail = async (to: string, task: Task) =>
  postNotification(
    '/api/notifications/task-assigned',
    {
      to,
      task: buildTaskNotificationPayload(task),
    },
    `Task assignment email sent to ${to}`,
    'Task assignment email failed'
  )

export const sendTaskNewApprovalEmail = async (to: string[], task: Task, requestedBy: string) => {
  console.log('Sending task approval request emails to approvers', {
    approverCount: to.length,
    approvers: to,
    taskId: task.id,
    taskTitle: task.title,
  })

  return postNotification(
    '/api/notifications/task-new-approval',
    {
      to,
      task: {
        ...buildTaskNotificationPayload(task),
        requestedBy,
        approvalPath: '/tasks?review=pending',
      },
    },
    `Task approval request email sent to ${to.length} approver(s)`,
    'Task approval request email failed'
  )
}

export const sendTaskReviewOutcomeEmail = async (
  to: string,
  task: Task,
  outcome: 'approved' | 'rejected',
  reviewedBy: string
) =>
  postNotification(
    '/api/notifications/task-review-outcome',
    {
      to,
      task: {
        ...buildTaskNotificationPayload(task),
        outcome,
        reviewedBy,
        taskPath: '/tasks',
      },
    },
    `Task review outcome email (${outcome}) sent to ${to}`,
    'Task review outcome email failed'
  )
